import http from '../http';

export default {
    all(usuario) {
        return http.get(`usuarios/${usuario}/verificaciones`)
    },
    create(usuario, payload) {
        return http.post(`usuarios/${usuario}/verificaciones`, payload)
    },
    get(usuario, verificacion) {
        return http.get(`usuarios/${usuario}/verificaciones/${verificacion}`)
    },
    delete(usuario, verificacion) {
        return http.delete(`usuarios/${usuario}/verificaciones/${verificacion}`)
    },
    verificacion(usuario) {
        return http.get(`verificacion/${usuario}/usuario`);
    },
    verificaciones(usuario){
        return http.get(`verificaciones/${usuario}`);
    },
    enviar(usuario){
        return http.get(`verificacion/${usuario}`);
    }
}